import { useContext } from 'react';

import { AuthContext, type AuthState } from './authContextValue';

/**
 * Acesso ao estado de autenticação.
 *
 * Fica em arquivo separado do provider porque o Fast Refresh do Vite só
 * funciona quando um módulo exporta apenas componentes — misturar hook e
 * componente derruba o recarregamento a quente e ninguém entende por quê.
 */
export function useAuth(): AuthState {
  const context = useContext(AuthContext);

  if (context === null) {
    throw new Error('useAuth precisa estar dentro de <AuthProvider>.');
  }

  return context;
}
